export enum TrafficControlMode {
  OneByOne = 'Call one by one',
  DecideWhoPicks = 'Decide who pickup first',
  VoiceMenu = 'Voice Menu',
}
